import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  loadingMatrizEvaluacion: false,
  matrizEvaluacionPuesto: [],
  modalMatrizEvaluacion: null,
  modalMatrizEvaluacionError: null,
  matrizEvaluacionPuestoError: "",
  formError: "",
};

export default function MatrizEvaluacionPuestoReducer(
  state = initialData,
  action
) {
  switch (action.type) {
    case actions.LOADING_MATRIZ_EVALUACION_PUESTO:
      return { ...state, loading: action.payload };
    case actions.LOADING_MODAL_MATRIZ_EVALUACION:
      return { ...state, loadingMatrizEvaluacion: action.payload };
    case actions.SAVE_LOADING_MATRIZ_EVALUACION_PUESTO:
      return { ...state, saveLoading: action.payload };
    case actions.GET_MATRIZ_EVALUACION_PUESTO:
      return { ...state, matrizEvaluacionPuesto: action.payload };
    case actions.GET_MODAL_MATRIZ_EVALUACION:
      return { ...state, modalMatrizEvaluacion: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.MATRIZ_EVALUACION_PUESTO_FAIL:
      return { ...state, matrizEvaluacionPuestoError: action.payload };
    case actions.MODAL_MATRIZ_EVALUACION_FAIL:
      return { ...state, modalMatrizEvaluacionError: action.payload };
    default:
      return state;
  }
}
